module.exports = __webpack_public_path__ + "images/frontpage_settings@2x.png?cc07563b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_settings@2x.png
// module id = 658
// module chunks = 7